import styled from 'styled-components';

export var UndoDeletionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
`;
